import axios, {AxiosRequestConfig} from 'axios'
import HttpStatusCode from './HttpStatusCode'

const TEMU_API_URL = process.env.REACT_APP_TEMU_ECOMMERCE_API_URL
const TEMU_API_VERSION = process.env.REACT_APP_TEMU_ECOMMERCE_API_VERSION
const BASE_URL = `${TEMU_API_URL}/${TEMU_API_VERSION}`

const post = (path: string, payload: any, config?: AxiosRequestConfig | undefined) => {
  return new Promise<any>((resolve, reject) => {
    axios
      .post(BASE_URL + path, payload, config)
      .then((response) => {
        if (response && response.status !== HttpStatusCode.OK) {
          processErrorResult(response)
          reject()
        } else {
          resolve(response.data)
        }
      })
      .catch((error) => {
        reject(error)
        //redirect('/Error')
      })
  })
}

function processErrorResult(response: any) {
  switch (response.status) {
    case HttpStatusCode.UNAUTHORIZED:
      break
    case HttpStatusCode.BAD_REQUEST:
    case HttpStatusCode.INTERNAL_SERVER_ERROR:
    default:
      redirect('/Error')
  }
}

function redirect(path: string) {
  window.location.href = window.location.origin + path
}

const RequestBaseTemu = {
  post,
  redirect,
}

export default RequestBaseTemu
